<template>
  <div class="detail-source-list">
    <template v-if="sources.length">
      <el-row class="resource-file" v-for="(source,index) in sources" :key="index">
        <el-col :span="platform === 'web' ? 10 : 12" class="padding-lr-sm">
          <div class="flex-container flex-row flex-verti-center">
            <el-tooltip :content="getSourceName(source)" placement="top">
              <span
                  class="source-name line-no-wrap"
                  @click="viewDetail(source)"
                  :class="{'view-detail':source.type==='comp'}">
                {{getSourceName(source)}}
              </span>
            </el-tooltip>
          </div>
        </el-col>
        <el-col v-if="platform === 'web'" :span="6" class="padding-lr-sm">
<!--          <span class="sub-info">适用软件：{{ source.softwareName }}</span>-->
          <span class="sub-info">适用软件：<software-display :software-arr="source.softwareList" /></span>
        </el-col>
        <el-col :span="platform === 'web' ? 6 : 10" class="padding-lr-sm">
          <span v-if="source.suffix === 'gac' && platform !== 'cs'" class="sub-info">软件分类：{{ source.softwareCategoryName }}</span>
        </el-col>
        <el-col :span="2" class="padding-lr-sm btn-col">
          <span class="btn" v-for="(btn,i) in source.btns" :key="i" @click="btn.click(source)">
            <i v-if="btn.icon" class="btn-icon" :class="btn.icon" />
            <span v-else>{{ btn.text }}</span>
          </span>
        </el-col>
      </el-row>
    </template>
    <div v-else class="resource-file-empty">
      <span>暂无资源</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import SoftwareDisplay from '@/components/business/SoftwareDisplay.vue'
export default {
  name: 'SourceList',
  components: { SoftwareDisplay },
  props: {
    // 是否显示载入按钮
    showLoadButton: {
      type: Boolean,
      default: true
    },
    // 是否显示布置按钮
    showPlaceButton: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      components: 'productDetail/relatedComponents',
      cadBlocks: 'productDetail/relatedBlocks',
      platform: 'platform',
    }),
    productId() {
      return this.$route.params.id
    },
    sources() {
      const final = []
      if (this.components.length === 0) {
        const data = JSON.parse(localStorage.getItem('relatedComponents'))
        if (!data) {
          return
        }
        data.forEach((comp) => {
          final.push({
            ...comp,
            softwareList: comp.softwareList || [{ softwareCode: comp.softwareCode, softwareName: comp.softwareName }],
            type: 'comp',
            btns: this.componentBtns
          })
        })
      } else {
        this.components.forEach((comp) => {
          final.push({
            ...comp,
            softwareList: comp.softwareList || [{ softwareCode: comp.softwareCode, softwareName: comp.softwareName }],
            type: 'comp',
            btns: this.componentBtns
          })
        })
      }

      if (this.platform === 'web') {
        this.cadBlocks.forEach((block) => {
          final.push({
            ...block,
            type: 'block',
            softwareList: [{ softwareCode: 'cad', softwareName: 'CAD' }],
            btns: [{
              text: '下载',
              icon: 'gjw-iconfont gjw-icon-wenjian-xiazai',
              click: this.downloadBlock
            }]
          })
        })
      }
      return final
    },
    componentBtns() {
      if (this.platform === 'r') {
        return this.showPlaceButton ? [
          {
            text: '布置',
            click: (comp) => this.$emit('place-revit-comp', comp)
          }
        ] : []
      } else if (this.platform === 'g') {
        const placeBtn = { text: '布置', click: (comp) => this.$emit('place-gcs-comp', comp) }
        const loadBtn = { text: '载入', click: (comp) => this.$emit('load-gcs-comp', comp) }
        const ret = []
        if (this.showPlaceButton) {
          ret.push(placeBtn)
        }
        if (this.showLoadButton) {
          ret.push(loadBtn)
        }
        return ret
      }
      return [
        {
          text: '下载',
          icon: 'gjw-iconfont gjw-icon-wenjian-xiazai',
          click: (comp) => this.webLoadComponent(comp)
        }
      ]
    }
  },
  methods: {
    ...mapMutations({
      setComponentInfo: 'componentDownload/setComponentInfo',
      setShowDialog: 'componentDownload/setShowDialog',
    }),
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
      loadRevitUrl: 'componentDownload/loadRevitUrl',
      loadTimes: 'componentDownload/loadTimes',
    }),
    viewDetail(source) {
      if (source.type === 'comp') {
        switch (this.platform) {
          case 'r':
            this.$emit('view-revit-comp', source)
            break
          case 'g':
            this.$emit('view-gcs-comp', source)
            break
          case 'cs':
            this.$emit('view-cs-comp', source)
            break
          case 'web':
            this.$emit('view-web-comp', source)
        }
      }
    },

    // web端下载
    async webLoadComponent(comp) {
      await this.loadUserInfo()
      if (this.user.id) {
        if (comp.platformCode === 'REVIT') {
          this.loadRevitUrl().catch()
          await this.loadTimes()
        }
        this.setComponentInfo(comp)
        this.setShowDialog(true)
      } else {
        this.$showLogin()
      }
    },
    // 产品图块下载
    async downloadBlock(block) {
      await this.loadUserInfo()
      if (this.user.id) {
        this.$message.success(this.$t('load.downloading'))
        const tempWin = window.open('', '_self')
        tempWin.location.href = await this.$api.products.blockDownloadUrl(block.id)
        // 图块下载埋点
        this.$tracks({
          event: 'cadBlockDownload',
          params: {
            g_c_cad_block_id: block.id,
            g_c_cad_block_name: `${block.name}.${block.suffix}`,
            g_c_product_id: block.productId
          }
        })
      } else {
        this.$showLogin()
      }
    },

    getSourceName(source) {
      return source.componentFamilyTypeName ? `${source.name}_${source.componentFamilyTypeName}.${source.suffix}` : `${source.name}.${source.suffix}`
    }

  }
}
</script>
<style lang='less' scoped>
.detail-source-list{
  margin-top: 11px;
  max-height: 184px;
  overflow-y: auto;
  .resource-file{
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: @bg-grey-dark;
    &:not(:first-child){
      margin-top: 8px;
    }
    &:hover{
      background: @theme-select-bg;
    }
  }
  .resource-file-empty{
    height: 40px;
    line-height: 40px;
    background: @bg-grey-dark;
    text-align: center;
    color: @theme-text-secondary;
  }
  .icon-img{
    margin-right: 10px;
  }
  .source-name {
    cursor: default;
    border-bottom: 1px solid transparent;
    position: relative;
    &::after{
      position: absolute;
      content: '';
      left: 0;
      bottom: 0;
      height: 1px;
      width: 0;
    }
    &.view-detail{
      cursor: pointer;
      &:hover{
        color: @theme-color;
        &::after{
          width: 100%;
          transition: all 0.2s;
          background-color: @theme-color;
        }
      }
    }
  }
  .sub-info{
    display: flex;
    flex-direction: row;
    align-items: center;
    color: @theme-text-secondary;
  }
  .btn-col{
    text-align: right;
  }
  .btn{
    color: @theme-color;
    cursor: pointer;
    margin-right: 8px;
    &:hover{
      color: @theme-hover-color;
    }
    .btn-icon{
      font-size: 1.48rem;
    }
  }
}
.padding-lr-sm{
   padding: 0 4px;
}
</style>
